export default {
  RETRIEVED_NOTIFICATIONS: store => {
    return store.notifications;
  }
};
